import { useEffect, useState } from 'react';
import { WorkflowOrder } from '../../../Api/Orders/ordersApi';
import { DetailViewCard } from '../../Compounds/CardWithTitle';
import { DetailRow } from '../../Compounds/DetailsDrawer/DetailRow';
import { getWorkflowOrdersLoadingSubject } from '../../../store/WorkflowOrder';
import { ComponentSpinner } from '../../Compounds/Loading/ComponentSpinner';
import { AttachmentTable } from '../../Compounds/AttachmentTable';
import { DetailsComments } from '../../Compounds/DetailsComments/DetailsComments';
import { shouldSeeComments } from '../../../store/User';
import { orderRequestDetailFields } from './orderRequestDetailFields';
import { orderFilesParentId, orderThreadId } from './orderKeys';

export interface WorkflowOrderDetailsProps {
  data: WorkflowOrder;
}

export function WorkflowOrderDetails({ data }: WorkflowOrderDetailsProps) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const sub = getWorkflowOrdersLoadingSubject().subscribe(setLoading);
    return () => sub.unsubscribe();
  }, []);

  const threadId = orderThreadId(data);

  const fields = orderRequestDetailFields(data);

  return (
    <>
      <DetailViewCard
        collapsed={false}
        enableCollapse
        key="order-request-details"
        title="Order Request Details">
        <div className="overflow-auto max-h-[30vh]">
          {loading && (
            <div className="mt-32">
              <ComponentSpinner />
            </div>
          )}
          {!loading &&
            fields.map((field) => (
              <DetailRow
                key={field.title}
                colId={field.title}
                title={field.title}
                value={field.value || '—'}
              />
            ))}
        </div>
      </DetailViewCard>
      {data.sf_id && (
        <AttachmentTable
          id={orderFilesParentId(data)}
          parentType="Opportunity"
          readOnly
        />
      )}
      {shouldSeeComments() && threadId && (
        <DetailsComments
          id={threadId}
          entityType="Opportunity"
          entityAccountId={data.account_id || ''}
        />
      )}
    </>
  );
}
